import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { ToastCustomContainer } from './style';
import Icon from '../../atoms/Icon';
import Text from '../../atoms/Text';

const Toast = () => {
  return null;
};

export const ToastInfo = ({ title, body }) => (
  <ToastCustomContainer className="info">
    <Icon type="info-circle" size={30} />
    <div>
      <Text type="h3.5">
        <p>{title}</p>
      </Text>
      {body && <Text type="b4">{body}</Text>}
    </div>
  </ToastCustomContainer>
);
ToastInfo.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
};

export const ToastSuccess = ({ title, body }) => (
  <ToastCustomContainer className="success">
    <Icon type="check-circle" size={30} />
    <div>
      <Text type="h3.5">
        <p>{title}</p>
      </Text>
      {body && <Text type="b4">{body}</Text>}
    </div>
  </ToastCustomContainer>
);
ToastSuccess.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
};

export const ToastError = ({ title = 'Errore', body }) => {
  const [msg, setMsg] = useState('');
  useEffect(() => {
    if (typeof body === 'string') setMsg(body);
    else setMsg(body?.message);
  }, [body]);

  return (
    <ToastCustomContainer>
      <Icon type="alert-circle" size={30} />
      <div>
        <Text type="h3.5">
          <p>{title}</p>
        </Text>
        {msg && <Text type="b4">{msg}</Text>}
      </div>
    </ToastCustomContainer>
  );
};
ToastError.propTypes = {
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

Toast.TYPE = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
};

Toast.show = (
  type = Toast.TYPE.DEFAULT,
  content = 'you miss to pass content'
) => {
  switch (type) {
    case Toast.TYPE.SUCCESS:
      toast.success(<ToastSuccess>{content}</ToastSuccess>);
      break;
    case Toast.TYPE.ERROR:
      toast.error(<ToastError>{content}</ToastError>);
      break;
    default:
      toast[type](content);
      break;
  }
};

Toast.propTypes = {};

export default Toast;
